import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import { MemberTypeForm } from 'components';
import { useAddMemberTypeMutation } from 'store/api/version-api.slice';

import { DEFAULT_MEMBER } from '../contants';
import { styles } from '../styles/addMemberTypes.styles';

const AddMemberTypes = () => {
	const [addMemberType, { isLoading }] = useAddMemberTypeMutation();

	const [memberType, setMemberType] = useState(DEFAULT_MEMBER);

	const handleAddMemberType = () => {
		addMemberType(memberType);
	};

	const onFormChange = (name, value) => {
		setMemberType(prev => ({
			...prev,
			[name]: value
		}));
	};

	return (
		<Paper sx={styles.createMemberTypesPaper}>
			<Typography component={'span'} color="secondary" variant="subtitle2">
				CREATE MEMBER TYPES
			</Typography>
			<MemberTypeForm
				allow_linked={memberType.allow_linked}
				linked_limit={memberType.linked_limit}
				member_type={memberType.member_type}
				amount={memberType.amount}
				renewal={memberType.renewal_type}
				billing={memberType.billing}
				visible={memberType.visible}
				free_type={memberType.free_type}
				handlePropChange={onFormChange}
			>
				<Button
					disabled={memberType.member_type.length === 0}
					sx={styles.addMemberTypeButton}
					color="primary"
					variant="contained"
					onClick={handleAddMemberType}
				>
					{isLoading && <CircularProgress sx={{ color: '#ffffff', marginRight: '8px' }} size={21} />}
					Add Member Type
				</Button>
			</MemberTypeForm>
			{isLoading && <Box sx={styles.overlay}></Box>}
		</Paper>
	);
};

export default AddMemberTypes;
